import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import useClearOutStockCart from '@features/cart/hooks/useClearOutStockCart'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

export default function ClearOutStockCart () {
  const { openClearOutStockModal } = useClearOutStockCart()
  const { t: tf } = useTranslation('favorites')

  return (
    <button
      type="button"
      className={cn(styles.root, 'reset-button')}
      onClick={openClearOutStockModal}
    >
      <ReactSVG src="/icons/trash.svg" wrapper="span" /> {tf('button.delete')}
    </button>
  )
}